export enum RewardShopViewTypeEnum {
  PRODUCTS = 'products',
  CATEGORY = 'category',
  PRODUCT_DETAIL = 'product_detail',
}
